import _attempt from "lodash/attempt";
export default () => _attempt(() => document.activeElement.blur());